import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

export const useUserFilter = () => {
  const defaultShowFilter = useSelector(
    (state) => state.users.usersList.item?.showFilter ?? false
  );
  const [filter, setFilter] = useState(defaultShowFilter);

  useEffect(() => {
    setFilter(defaultShowFilter);
  }, [defaultShowFilter]);

  const toggleFilter = () => setFilter(prev => !prev);

  return [filter, toggleFilter];
};